// extracted by mini-css-extract-plugin
export var completionBody = "_dy-2";
export var completionCard = "_dy-0";
export var completionFooter = "_dy-3";
export var completionTitle = "_dy-1";